var generateStyle = function generateStyle() {
  return {
    answerFeedbackWrapper: {
      minWidth: '0' // needed to prevent codemirror from overflowing
    },
    choiceInputWrapper: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gridTemplateRows: 'auto auto'
    },
    doneButton: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
};
export default generateStyle;